export const ERROR_NOISE_PATTERNS = [
    /Timeout waiting for mutex/,
    /Invalid PixelID/,
    /enableDidUserTypeOnKeyboardLogging/,
    /Failed to fetch dynamically imported module/,
    /Importing a module script failed/,
    /Java object is gone/,
    /WebSocket is closed before the connection is established/,
    /Facebook Pixel blocked/,
    /Duplicate Pixel ID/,
    /Service worker is not supported/,
    /Can't find variable: __AutoFillPopupClose__/,
    /feature named .* was not found/,
    /WKWebView API client did not respond/,
    /(?:window|top)\.webkit\.messageHandlers/,
    /ObjectMultiplex - malformed chunk/,
    /^Script error\.?$/,
    /installations\/app-offline/,
    /ResizeObserver loop completed with undelivered notifications/,
    /ResizeObserver loop limit exceeded/,
    /Object Not Found Matching Id/,
];
//# sourceMappingURL=error-noise-patterns.const.js.map